interface LargeOccupancyAffordabilityRankingEligibilityParams {
  rooms: Array<App.Occupants> | undefined
  searchType: App.SearchItem['searchType']
}

/**
 * Excluded baseline occupancies: 1A, 2A, 3A, and 2A+1C with no infants/teenagers.
 * Any infants or teenagers make the party non-baseline (eligible), matching the
 * spirit of isStandardOccupancy treating non-zero infants as non-standard.
 */
function isExcludedBaselineOccupancy(room: App.Occupants): boolean {
  const adults = room.adults
  const children = room.children ?? 0
  const infants = room.infants ?? 0
  const teenagers = room.teenagers ?? 0

  if (infants > 0 || teenagers > 0) return false

  if (children === 0 && (adults === 1 || adults === 2 || adults === 3)) {
    return true
  }

  return adults === 2 && children === 1
}

export function isLargeOccupancyAffordabilityRankingEligible({
  rooms,
  searchType,
}: LargeOccupancyAffordabilityRankingEligibilityParams): boolean {
  if (searchType === 'landmark' || searchType === 'property') return false
  if (rooms?.length !== 1) return false

  const [room] = rooms
  return !isExcludedBaselineOccupancy(room)
}
